<template>
  <div>
    <!-- 2. Correct answers -->
    <div
      class="form-check form-check-inline"
    >
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="check-correct-option"
          v-model="slideActive.addCorrectOption"
          @change="$emit('updateSettingSlide', 4)"
        >
        <label
          class="custom-control-label"
          for="check-correct-option"
        >{{ $i18nPresenter.t('This question has correct answer(s)') }}</label>
        <span class="pl-1 title-table-presentation-tooltip tooltip-on-hover">
          <b-button
            v-tooltip="$i18nPresenter.t('Mark one or more options as correct and reveal them to your participants.')"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
      </div>
    </div>

    <div class="mr-0 form-check form-check-inline">
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="check-multiple-choice"
          :checked="slideActive.multipleChoice"
          @change="handleChangeMultipleChoice"
        >
        <label
          class="custom-control-label"
          for="check-multiple-choice"
        >{{ $i18nPresenter.t('Allow picking more than one option') }}</label>
        <span
          class="pl-1 title-table-presentation-tooltip tooltip-on-hover"
        >
          <b-button
            v-tooltip="pickMoreTooltip"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
      </div>
      <div class="pt-2 horizontal layout center justified" v-if="slideActive.multipleChoice">
        <div class="multiple-options-label">
          {{ $i18nPresenter.t('Max picks') }}
        </div>
        <div
          class="relative multiple-options-content horizontal layout center"
        >
          <select
            class="w-full h-full rounded px-2 py-1 cursor-pointer appearance-none"
            @change="handleChangeLimitChoice"
            @click="handleClickLimitChoice"
            v-if="limitOptionLength > 1"
          >
            <option
              v-for="(value, index) in limitOptionLength - 1"
              :key="index"
              :value="value + 1"
              :selected="slideActive.limitChoice == value + 1"
            >
              {{ value + 1 === limitOptionLength ? $i18nPresenter.t('All') : value + 1 }}
              {{ $i18nPresenter.t('options') }}
            </option>
          </select>
          <select
            v-else
            @click="handleClickLimitChoice"
            class="w-full h-full rounded px-2 py-1 cursor-pointer appearance-none"
          >
            <option>
              {{ $i18nPresenter.t('All') }} {{ $i18nPresenter.t('options') }}
            </option>
          </select>
          <aha-icon
            class="absolute pointer-events-none top-3 right-2"
            name="arrow"
            viewBox="0 0 24 24"
            width="12"
            height="12"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Utils from '@/util'
import { PRESENTATION_EDITOR } from '@/constant/eventCategories'
import { ALLOW_PICKING_MORE_OPTION_NAME, SELECT_MORE_OPTION } from '@/constant/eventActions'

export default {
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    pickMoreTooltip() {
      return this.$i18nPresenter.t('Your audience can vote for 2 or more options in the poll')
    },
    isErrorLimitChoiceVisible() {
      const { limitChoice } = this.slideActive
      return !limitChoice ||
      limitChoice < 2 ||
        limitChoice > this.getMaxLimitOption()
    },
    limitOptionLength() {
      return this.slideActive.SlideOptions ? this.slideActive.SlideOptions.filter((option) => option.id).length : 0
    },
  },

  watch: {
    isMultipleOptionsCanPickVisible: function watchLimitChoice() {
      if (this.slideActive.limitChoice > this.getMaxLimitOption()) {
        this.slideActive.limitChoice = this.getMaxLimitOption()
      }
      this.$emit('updateSettingSlide', 2)
    },
  },

  methods: {
    getMaxLimitOption() {
      let count = 0
      this.slideActive.SlideOptions.forEach((item) => {
        if (item.id) count++
      })
      return count
    },
    handleChangeLimitChoice(event) {
      // eslint-disable-next-line prefer-destructuring
      const value = parseInt(event.target.value, 10)
      this.slideActive.limitChoice = value
      if (!value || value < 2) return
      if (value > this.getMaxLimitOption()) {
        this.slideActive.limitChoice = 1
      }
      if (this.isErrorLimitChoiceVisible) return
      this.$emit('updateSettingSlide', 2)
      const trackData = {
        eventAction: SELECT_MORE_OPTION,
        eventCategory: PRESENTATION_EDITOR,
        eventLabel: value,
        presentationId: this.presentation.id,
        slideType: this.slideActive.type,
        slideId: this.slideActive.id,
      }
      Utils.trackGA4AndMixpanel(SELECT_MORE_OPTION, trackData)
    },
    handleChangeMultipleChoice() {
      this.$emit('updateSettingSlide', 1, null, {
        multipleChoice: !this.slideActive.multipleChoice,
      })
    },
    onHideDropdown() {
      const elem = document.querySelector('.aha-modal__content')
      if (elem) {
        elem.style.height = null
      }
    },
    handleClickLimitChoice() {
      const trackData = {
        eventAction: ALLOW_PICKING_MORE_OPTION_NAME,
        eventCategory: PRESENTATION_EDITOR,
        presentationId: this.presentation.id,
        slideType: this.slideActive.type,
        slideId: this.slideActive.id,
      }
      Utils.trackGA4AndMixpanel(ALLOW_PICKING_MORE_OPTION_NAME, trackData)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.pick-option-point {
  padding-left: 23px;
  .form-check-inline {
    margin: 12px 0;
  }
}

.label-option-small {
  font-size: 14px !important;
  color: #313131 !important;
  padding-left: 10px;
  padding-left: 23px;
  font-weight: normal;
}

.multiple-options-label {
  padding-left: 1.5rem;
}

.multiple-options-content {
  width: 171px;
  height: 40px;
  @apply border border-secondary-20 rounded;

  &:hover {
    border-color: #4f9af2;
  }
  & ::v-deep .aha-input {
    width: 121px;
    padding-right: 60px;
  }
  .multiple-options-box {
    width: 35px;
    height: 35px;
  }
  & ::v-deep .context-menu-wrapper{
    width: 171px;
  }
}
#multiple-options {
  display: flex;
  height: 36px;
}
</style>
